
/**
 * 生成uuid
 *
 * @return {string}
 */
export const uuid = () => {
  const random = (Math.random() * 2 ** 32).toString(36);
  const timestamp = new Date().getTime();
  return 'u-' + timestamp + '-' + random;
};

export function loadScript(src, allowOnlyOne) {
  loadScript._cachePromises = loadScript._cachePromises || {};
  const cachePromise = loadScript._cachePromises[src];
  // 若同一脚本 只允许加载一次 且 已有缓存
  if (allowOnlyOne && cachePromise) {
    return cachePromise;
  }

  const loadPromise = new window.Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.defer = true;
    script.src = src;
    script.onload = () => resolve(true);
    script.onerror = () => {
      reject(false);

      // 加载失败，允许再次加载
      if (allowOnlyOne) {
        document.head.removeChild(script);
        delete loadScript._cachePromises[src];
      }
    };
    script.onreadystatechange = () => {
      if (
        script.readyState === 'loaded' ||
        script.readyState === 'complete'
      ) {
        resolve(true);
      }
    };
    // 默认 允许重复加载脚本
    if (!allowOnlyOne) {
      document.head.appendChild(script);
    } else {
      const scriptList = Array.from(
        document.head.querySelectorAll('script')
      );
      const isExists = scriptList.some(script => script.src === src);
      if (!isExists) {
        document.head.appendChild(script);
      }
    }
  });

  loadScript._cachePromises[src] = loadPromise;

  return loadPromise;
}

export const isIE = () => navigator.userAgent.toLowerCase().indexOf('trident') > -1;
